import './Footer.css';
import { useEffect, useState } from "react";
import logo from '../../Assets/invertedexistenceMedia.png';
import facebook from '../../Assets/facebook.png';
import instagram from '../../Assets/instagram.png';

const Footer = () => {
    const [mobileVersion, setMobileVersion] = useState(window.innerWidth <= 1024);
    const [showTermsModal, setShowTermsModal] = useState(false);
    const [showPrivacyModal, setShowPrivacyModal] = useState(false); // State for Privacy Policy modal

    useEffect(() => {
        const handleResize = () => {
            setMobileVersion(window.innerWidth <= 885);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleTermsClick = () => {
        setShowTermsModal(true);
    };

    const handlePrivacyClick = () => {
        setShowPrivacyModal(true);
    };

    const handleCloseModal = () => {
        setShowTermsModal(false);
        setShowPrivacyModal(false);
    };

    return (
        <>
            <footer id={mobileVersion ? 'footer-mb' : 'footer-dskt'}>
                <div className={mobileVersion ? '' : 'footer'}>
                    <div className='backgroundcolorFooter'></div>
                    <div className={mobileVersion ? 'company-info company-info-mb' : 'company-info company-info-dskt'}>
                        <div className={mobileVersion ? 'logo-mb' : 'logo'}>
                            <img src={logo} alt="Logo" />
                        </div>
                        <h3>EMAIL</h3>
                        <p>
                            <a className={mobileVersion ? 'redirect-link redirect-link-mb' : 'redirect-link redirect-link-dskt'}>
                                info@existence-media.com
                            </a>
                        </p>
                        <h3>SOCIAL MEDIAS</h3>
                        <div className={mobileVersion ? 'social-media-logos-mb' : 'social-media-logos'}>
                            <a href="https://www.instagram.com/kodrasoftware" target="_blank" rel="noopener noreferrer">
                                <img src={instagram} alt="Instagram" />
                            </a>
                            <a href="https://www.facebook.com/profile.php?id=61553175934000" target="_blank" rel="noopener noreferrer">
                                <img src={facebook} alt="Facebook" />
                            </a>
                        </div>
                    </div>
                    <div className={mobileVersion ? 'terms-privacy terms-privacy-mb' : 'terms-privacy terms-privacy-dskt'}>
                        <p>
                            <a onClick={handleTermsClick}>Terms and Conditions</a>
                        </p>
                        <p>
                            <a onClick={handlePrivacyClick}>Privacy Policy</a>
                        </p>
                    </div>
                    <p className='copyright'>
                        <a>2024 © All Rights reserved</a>
                    </p>
                </div>
            </footer>

            {/* Terms Modal */}
            {showTermsModal && (
                <div className="modal-overlay" onClick={handleCloseModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <h2>Terms and Conditions</h2>
                        <p>
                            <h2>1. General</h2>
                            This website is owned and operated by Existence Media. By accessing or using this website, you agree to these terms and conditions.
                            <h2>2. Services</h2>
                            We specialize in video editing services. All information provided on this website is for informational purposes only.
                            <h2>3. Data Usage</h2>
                            This website does not collect, store, or process any user data. Your visit is entirely anonymous.
                            <h2>4. Intellectual Property</h2>
                            All content on this website, including text, images, and videos, is the property of Existence Media and is protected by copyright laws. Reproduction or redistribution of this content without permission is prohibited.
                            <h2>5. External Links</h2>
                            Our website may include links to third-party websites. We are not responsible for the content or practices of these websites.
                            <h2>6. Limitation of Liability</h2>
                            We are not liable for any damages arising from the use of this website. The website is provided "as is" without warranties of any kind.
                           
                        </p>
                        <button onClick={handleCloseModal}>Close</button>
                    </div>
                </div>
            )}

            {/* Privacy Modal */}
            {showPrivacyModal && (
                <div className="modal-overlay" onClick={handleCloseModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <h2>Privacy Policy</h2>
                        <p>
                            <h2>1. Data Collection</h2>
                            This website does not collect, store, or process any user data. Your visit is completely anonymous.
                            <h2>2. Cookies</h2>
                            We do not use cookies or any tracking technologies on this website.
                            <h2>3. External Links</h2>
                            Our website may include links to third-party websites. We are not responsible for the privacy practices of these websites.
                            <h2>4. Updates</h2>
                            We reserve the right to update this privacy policy at any time. Please check this page periodically for updates.
                        </p>
                        <button onClick={handleCloseModal}>Close</button>
                    </div>
                </div>
            )}
        </>
    );
};

export default Footer;
